// @flow
import React, { Component, type Node } from 'react';
import { BrandedLink, GreyLink } from './LinkStyles';

type Props = {|
  grey?: boolean,
  href: string,
  children: Node,
  bold?: boolean
|};

export default class ExternalLink extends Component<Props> {
  render() {
    return this.props.grey ? (
      <GreyLink rel="noopener noreferrer" target="_blank" {...this.props} />
    ) : (
      <BrandedLink rel="noopener noreferrer" target="_blank" {...this.props} />
    );
  }
}
